import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const defaultBannersState = {
    data: [],
    error: null,
};

const getBannersReducer = (state, action) => {
    return {
        data: action.payload.banners,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultBannersState,
    };
};

export const bannersSlice = createSlice({
    name: 'banners',
    initialState: defaultBannersState,
    reducers: {
        getBanners: getBannersReducer,
        reset: resetReducer,
    },
});

const getBanners = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getBanners' }));
    const result = await apiClient.getBanners(payload);
    dispatch(bannersSlice.actions.getBanners(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getBanners' }));
};

// actions that get exported to the views
export const bannersActions = (dispatch) => {
    return {
        getBanners: (payload) => getBanners(dispatch, payload),
        reset: (payload) => dispatch(bannersSlice.actions.reset(payload)),
    };
};
